import { render } from "./DocumentaryCard.vue?vue&type=template&id=5249bc40&scoped=true"
import script from "./DocumentaryCard.vue?vue&type=script&lang=js"
export * from "./DocumentaryCard.vue?vue&type=script&lang=js"

import "./DocumentaryCard.vue?vue&type=style&index=0&id=5249bc40&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5249bc40"]])

export default __exports__